"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerLayout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const overlayscrollbars_react_1 = require("overlayscrollbars-react");
const useWindowSize_1 = __importDefault(require("react-use/lib/useWindowSize"));
const mediaQuery_enum_1 = require("../../core/mediaQuery.enum");
const DesktopDrawer_1 = require("./desktopDrawer/DesktopDrawer");
const MobileDrawer_1 = require("./mobileDrawer/MobileDrawer");
const Styled = __importStar(require("./DrawerLayout.styles"));
const DrawerLayout = (props) => {
    const { width } = (0, useWindowSize_1.default)();
    return width > mediaQuery_enum_1.MediaQuery.MEDIUM ? ((0, jsx_runtime_1.jsx)(overlayscrollbars_react_1.OverlayScrollbarsComponent, { defer: true, options: { scrollbars: { autoHide: 'scroll' } }, children: (0, jsx_runtime_1.jsxs)(Styled.Container, { children: [(0, jsx_runtime_1.jsx)(DesktopDrawer_1.DesktopDrawer, { ...props }), (0, jsx_runtime_1.jsx)(Styled.Content, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {}) })] }) })) : ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(MobileDrawer_1.MobileDrawer, { ...props }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {})] }));
};
exports.DrawerLayout = DrawerLayout;
